import Vue from "vue";

export default {
  async get(table, search) {
    const response = await Vue.axios.get(
      `data/${table}?search=${search}&withGeom`
    );
    return response.data;
  }
};
